import React, { memo } from "react";
import { CategoryTitleWrapper } from "./style";

const KTCategoryTitle = memo(({ title }) => {
  return <CategoryTitleWrapper>{title}</CategoryTitleWrapper>;
});

export default KTCategoryTitle;
